'use client';

import AboutContent from './Components/AboutContent';
import PopularItems from './Components/PopularItems';
import MainHeader from 'Components/Header';
import PaymentSystem from './Components/PaymentSystem';
import { RestrictionComponentModal } from '@/Components/RestrictionComponent';

const MainPage = () => {
  return (
    <>
      <MainHeader />
      <AboutContent />
      <PaymentSystem />
      <PopularItems />
      <RestrictionComponentModal />
    </>
  );
};

export default MainPage;
